import { IPost } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import { IAppStore } from '../../HomeWorkouts';
import { defaultScale } from '../../utils';
import { isMobile } from '../../utils/ScreenSizes';
import { blogPostModalClosed } from '../redux';
import BaseModal from './BaseModal';

interface IMappedState {
  modalOpen: boolean;
  post: IPost | null;
}

interface IMappedDispatch {
  closeModal: () => void;
}

const BlogPostModalComponent: FunctionComponent<IMappedState & IMappedDispatch> = (
  {
    modalOpen,
    closeModal,
    post,
  },
) => {
  const content = () => {
    if (post?.videoUrl) {
      return (
        <video
          width='100%'
          height={isMobile() ? '100%' : defaultScale(700)}
          controls
          autoPlay
          key={post.videoUrl}
        >
          <source src={post.videoUrl} type='video/mp4' />
        </video>
      );
    }

    if (post?.url) {
      return (
        <View style={{ height: window.window.innerHeight * 0.83 }}>
          <iframe
            height={isMobile() ? '100%' : defaultScale(800)}
            src={post.url}
            style={{ border: 'none', height: '100%' }}
            key={post.url}
          />
        </View>
      );
    }

    return <></>;
  };

  return (
    <BaseModal
      title={post?.videoUrl && post?.title}
      closeModal={closeModal}
      isModalVisible={modalOpen}
      useFullWidth
      containerStyle={{
        height: '100%',
      }}
    >
      {content()}
    </BaseModal>
  );
};

const styles = StyleSheet.create({
  bodyStyle: {
    paddingHorizontal: 0,
    paddingVertical: 0,
    flex: 1,
  },
});

const mapStateToProps = (state: IAppStore): IMappedState => ({
  modalOpen: state.ui.blogPostModalOpen,
  post: state.ui.postOpenInBlogPostModal,
});

const mapDispatchToProps = (dispatch): IMappedDispatch => ({
  closeModal: () => dispatch(blogPostModalClosed()),
});

export const BlogPostModal = connect(mapStateToProps, mapDispatchToProps)(BlogPostModalComponent);
